import { render, staticRenderFns } from "./AdminContrattiFuturiView.vue?vue&type=template&id=a3cfd9a0&"
import script from "./AdminContrattiFuturiView.vue?vue&type=script&lang=ts&"
export * from "./AdminContrattiFuturiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports